export default "__VITE_ASSET__7kH$f2Sy__"